<template>
	<div class="title tec" :class="{'line':line}"> 
		<h2 class="b"><span>{{title}}</span></h2>
		<p class="c9">{{desc}}</p>
	</div>
</template>

<script>
	export default{
		props:{
			title:{
				type:String,
				default:''
			},
			desc:{
				type:String,
				default:''
			},
			line:{
				type:Boolean,
				default:false
			}
		}
	}
</script>

<style scoped> 
.title{
	padding: 4rem 0 4rem;
}
.title h2{
	font-size: 2.86rem;
	line-height: 5rem;
	letter-spacing: 0.2em;
}
.line span{
	position: relative;
}
.line span::before{
	content: '';
	width: 6rem;
	height: 2px;
	background-color: #986F5A;
	left: -8rem;
	position: absolute;
	top: 48%;
}
.line span::after{
	content: '';
	width: 6rem;
	height: 2px;
	background-color: #986F5A;
	right: -8rem;
	position: absolute;
	top: 48%;
}
.title p{
	font-size: 1rem;
	text-transform:uppercase;
	letter-spacing: 0.2em;
}
	@media screen and (max-width: 750px) {
		.title{
			display: none;
		} 
	}
</style>